import React, { useState, useEffect } from "react";
import s from "./Navbar.module.css";
import { Link } from "react-scroll";
import logo from "../../assets/images/tab_icon1.png"

function Navbar({ isSidebarOpen, toggleSidebar, setIsScrolled, isScrolled }) {
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > window.innerHeight - 72); // Hero section sonrası navbar beyaz
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`${s.navbar_container} ${
        isScrolled ? s.navbar_white : s.navbar_transparent
      }`}
    >
       <div className={s.nav_logo_container}>
    <img
      src={logo}
      alt="Logo"
      className={s.nav_logo}
    />
  </div>
      {!isSidebarOpen && (
        <button
          style={{ color: isScrolled ? "var(--primary1)" : "#fff" }}
          className={s.sidebarToggle}
          onClick={toggleSidebar}
        >
          ☰
        </button>
      )}
      <span
        style={{ cursor: "pointer" }}
        className={`${s.navbar_item} ${
          isScrolled ? s.navbar_item_grey : s.navbar_item_white
        }`}
      >
        <Link smooth={true} duration={500} to="main">
          Ana Sayfa
        </Link>
      </span>
      <span
        style={{ cursor: "pointer" }}
        className={`${s.navbar_item} ${
          isScrolled ? s.navbar_item_grey : s.navbar_item_white
        }`}
      >
        <Link smooth={true} duration={500} to="about" offset={-90}>
          Hakkımızda
        </Link>
      </span>
      {/* <div className={s.navbar_button}>
        <Link
          style={{ padding: "0", fontWeight: "bold" }}
          smooth={true}
          duration={500}
          to="avidef"
        >
          AVIDEF
        </Link>
      </div> */}
      <span
        style={{ cursor: "pointer" }}
        className={`${s.navbar_item} ${
          isScrolled ? s.navbar_item_grey : s.navbar_item_white
        }`}
      >
        <Link  offset={-200} smooth={true} duration={500} to="services">
          Hizmetlerimiz
        </Link>
      </span>
      <span
        style={{ cursor: "pointer" }}
        className={`${s.navbar_item} ${
          isScrolled ? s.navbar_item_grey : s.navbar_item_white
        }`}
      >
        <Link    offset={-200}  smooth={true} duration={500} to="chooseUs">
          Neden Biz?
        </Link>
      </span>
      <span
        style={{ cursor: "pointer" }}
        className={`${s.navbar_item} ${
          isScrolled ? s.navbar_item_grey : s.navbar_item_white
        }`}
      >
        <Link  offset={-200}  smooth={true} duration={500} to="OurTeam">
          Ekibimiz
        </Link>
      </span>
      <span
        style={{ cursor: "pointer" }}
        className={`${s.navbar_item} ${
          isScrolled ? s.navbar_item_grey : s.navbar_item_white
        }`}
      >
        <Link smooth={true} duration={500} to="contact_form">
          İletişim
        </Link>
      </span>
    </div>
  );
}

export default Navbar;
